// 領収書発行ウィジェットの CSS（Issue #46）。
//
// ★★ここが持つのは「構造」だけ。「装飾」は各店のフリーページの <style> が持つ。
//
//   構造 = ラベルと値の横並び・折り返し・入力欄の体裁・崩れない最低限の見た目  ← ここ
//   装飾 = 見出しの色・ボタンの画像・余白・リンクの見た目                      ← 各店
//
// なぜ分けるか（2026-09-17 の事故）:
//   おちゃのこのテーマCSS（ocnk.min.css）から Bootstrap の .input-group{display:flex} が落ちて、
//   11ページ全部でラベルと値が縦に並んだ。原因は「横並びという構造を、外部のテーマCSS任せにしていた」こと。
//   ⇒ 構造は自分で持つ。フリーページに <style> が1行も無くても読める形で出ること。
//
// ★セレクタは「単一クラス」だけを使う（詳細度 0,1,0 に揃える）。理由は2つ:
//   1. この <style> は head に入り、店の <style> はページ本文＝後ろに来る。
//      同じ詳細度なら後ろが勝つので、店は同じクラス名を書くだけで上書きできる
//      （.wu-receipt .wu-receipt-row のように入れ子で書くと 0,2,0 になり、店が上書きできなくなる）。
//   2. 素のタグセレクタを一切使わないので、店のテーマを壊さない。
//      逆に、テーマ側のタグセレクタ（例 #main_container input）は 0,1,0 に届かないので、こちらが勝つ。
//
// ★クラス名は各店の CSS から参照される契約。変えるときは全11ページの <style> も直すこと（template.ts の注記も参照）。

export const CSS = `
.wu-receipt{
  max-width:680px; margin:0 auto; text-align:left; line-height:1.7;
  color:#222; font-family:"Hiragino Kaku Gothic ProN","Hiragino Sans","Yu Gothic","Meiryo",sans-serif;
}
.wu-receipt-state{ margin:0 0 24px; }
.wu-receipt-title{ font-size:18px; font-weight:bold; margin:0 0 12px; padding:8px 12px; background:#eee; text-align:center; }
.wu-receipt-lead{ margin:0 0 16px; }

.wu-receipt-errors{ margin:0 0 12px; padding:0 0 0 1.4em; color:#c00; }
.wu-receipt-error-item{ margin:2px 0; }

.wu-receipt-box{ margin:0 0 16px; padding:16px; border:1px solid #ccc; background:#f6f6f6; }
.wu-receipt-row{ display:flex; align-items:baseline; flex-wrap:wrap; gap:4px 10px; padding:6px 0; }
.wu-receipt-label{ flex:0 0 10.5em; text-align:right; font-weight:bold; }
.wu-receipt-value{ flex:1 1 12em; min-width:0; overflow-wrap:break-word; }

.wu-receipt-input{ box-sizing:border-box; width:100%; max-width:22em; padding:6px 8px; font-size:16px; font-family:inherit; border:1px solid #999; background:#fff; color:inherit; }
.wu-receipt-select{ box-sizing:border-box; max-width:100%; padding:6px 8px; font-size:16px; font-family:inherit; border:1px solid #999; background:#fff; color:inherit; }
.wu-receipt-unit{ margin-left:4px; }
.wu-receipt-yen{ margin-left:2px; }
.wu-receipt-price{ font-size:1.2em; font-weight:bold; }
.wu-receipt-help{ display:inline-block; margin-left:6px; font-size:0.85em; color:#666; }

.wu-receipt-actions{ margin:16px 0 0; text-align:center; }
.wu-receipt-button{ display:inline-block; padding:12px 28px; font-size:16px; font-weight:bold; font-family:inherit; line-height:1.4; color:#fff; background:#c00; border:none; cursor:pointer; }
.wu-receipt-button:disabled{ opacity:.6; cursor:default; }
.wu-receipt-button-label{ display:inline-block; }

/* 別注版の「領収書ダウンロード」（<a>）。見た目はボタンに揃える。画像にする店は button と同じ要領で上書きする */
.wu-receipt-download{ display:inline-block; padding:12px 28px; font-size:16px; font-weight:bold; font-family:inherit; line-height:1.4; color:#fff; background:#c00; border:none; text-decoration:none; cursor:pointer; }
.wu-receipt-download-label{ display:inline-block; }

.wu-receipt-toplink{ display:inline-block; margin-top:12px; }
.wu-receipt-note{ margin:8px 0 0; }

/* ラベルの右寄せは横並びのときだけ意味がある。縦に積むときは左に戻す。 */
@media (max-width:480px){
  .wu-receipt-label{ flex:1 1 100%; text-align:left; }
  .wu-receipt-value{ flex:1 1 100%; }
}

/* プレビュー（?wu_receipt_preview=）の見出し。本番のお客様には出ない。 */
.wu-receipt-preview-bar{ margin:0 0 8px; padding:4px 8px; background:#333; color:#fff; font-size:12px; }
`
